/**
 * 获取echart默认配置
 * @returns {{title: {subtext: string, left: string, textAlign: string, subtextStyle: {fontSize: string, fontWeight: string}}}}
 */

export default function () {
  return {
    title: {
      subtext: '测试',
      left: '48%',
      textAlign: 'center',
      subtextStyle: {
        fontSize: '16px',
        fontWeight: 'bolder'
      }
    }
  }
}
